import { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getToken } from '@/lib/tokenStorage';
import { countryStore } from '@/stores/country.store';

export function ProtectedLayout() {
  const [token] = useState(() => getToken());

  useEffect(() => {
    if (token) void countryStore.load();
  }, [token]);

  if (!token) return <Navigate to='/login' replace />;
  return <Outlet />;
}
